// eslint-disable-next-line @typescript-eslint/no-namespace,unused-imports/no-unused-vars
namespace TescoSW.Global {

/**
 * Simulace metody process.nextTick v node.js
 */
    // @ts-ignore // nevyužito, ale ponecháno
    // eslint-disable-next-line unused-imports/no-unused-vars
    const Process: { NextTick: (callback: () => void) => void } = {
        NextTick: (function() {
            const canSetImmediate = typeof window !== "undefined"
                && (window as any).setImmediate;
            const canPost = typeof window !== "undefined"
                && window.addEventListener;

            if (canSetImmediate) {
                return function(callback: () => void) {
                    return (window as any).setImmediate(callback);
                };
            }

            if (canPost) {
                const queue: Array<() => void> = [];
                window.addEventListener("message", function(ev) {
                    const source = ev.source;
                    if ((source === window || source === null) && ev.data === "process-tick") {
                        ev.stopPropagation();
                        if (queue.length > 0) {
                            const fn = queue.shift();
                            fn?.();
                        }
                    }
                }, true);

                return function nextTick(callback: () => void) {
                    queue.push(callback);
                    window.postMessage("process-tick", "*");
                };
            }

            return function nextTick(callback: () => void) {
                self.setTimeout(callback, 0);
            };
        })(),
    };
}
